import React from "react";
import { Pie } from "react-chartjs-2";
import Chart from 'chart.js/auto';

const data = {
  labels: ["Number of tickets handled", "Missed contact"],
  datasets: [
    {
      data: [300, 50],
      backgroundColor: ["#36A2EB", "#FFCE56"],
      hoverBackgroundColor: ["#36A2EB", "#FFCE56"],
    },
  ],
};

const options = {
  legend: {
    display: true,
    position: "bottom",
    labels: {
      fontColor: "#333",
      fontSize: 12,
      usePointStyle: true,
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};

const PieChart = () => (
  <div style={{height:'25rem'}}>
    <Pie data={data} options={options} />
  </div>
);

export default PieChart;
